<template>
  <ODialog ref="dialog" :max-width="1200" hideWhenLoading :persistent="isDirty">
    <v-card v-if="row != null">
      <ODialogBar
        title="Teclado Checklist"
        :subtitle="subtitle"
        @close="dismiss"
      >
        <v-spacer />
        <v-btn icon target="_blank" :to="'/setup/keyboards/' + row.id">
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </ODialogBar>
      <v-card-text class="dialog-main">
        <div class="dialog-sidebar">
          <DesktopSideBar :tabItems="tabItems" :currentTab.sync="currentTab" />
        </div>

        <div class="dialog-tab-content">
          <TabContainer
            @reload="reload"
            :tabItems="tabItems"
            :currentTab="currentTab"
            :value="row"
          />
        </div>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import DesktopSideBar from 'oderon-vue/cpts/tabbed-interface/DesktopSideBar.vue'
import TabContainer from 'oderon-vue/cpts/tabbed-interface/TabContainer.vue'
import EditStore from './EditStore'

export default {
  components: {
    DesktopSideBar,
    TabContainer
  },
  computed: {
    currentTab: {
      get() {
        return EditStore.currentTab
      },
      set(x) {
        EditStore.currentTab = x
      }
    },
    row() {
      return EditStore.row
    },
    isDirty() {
      return EditStore.isDirty
    },
    subtitle() {
      const id = this.row && this.row.id
      const serial = this.row && this.row.imei
      if (id == null || serial == null) return null
      return `ID #${this.row.id} ─ Serial ${this.row.serial}`
    },
    tabItems() {
      return EditStore.tabItems
    }
  },
  methods: {
    open(id) {
      this.$refs.dialog.$loading(() => EditStore.load(id))
      return this.$refs.dialog.$open()
    },
    reload() {
      this.$refs.dialog.$loading(() => EditStore.load(this.row.id))
    },
    dismiss() {
      return this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style lang="sass"></style>
